import { Injectable } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { FormService } from '@shared/core/services/form.service';
import { ValidationRulesService } from '@shared/services/validation/validation-rules.service';

@Injectable()
export class QuestionsFormService extends FormService<UntypedFormGroup> {
  constructor(
    private builder: UntypedFormBuilder,
    private validationRule: ValidationRulesService
  ) {
    super();
    this.create();
  }

  isPending = false;

  protected create(): void {
    this.form = this.builder.group({
      personalInfo: ['', [this.validationRule.name(), Validators.required]],
      email: ['', [this.validationRule.email(), Validators.required]],
      comment: ['', Validators.required],
      accept: [false, Validators.requiredTrue],
    });
  }
}
